import React from 'react';
import PropTypes from 'prop-types';
import Modal from '@nexus/fff-ui-shared/Modal';
import Button from '@nexus/fff-ui-shared/Button';

import styles from './WarningModal.module.scss';

const WarningModal = ({
  isOpen,
  title,
  message,
  cancelText,
  confirmText,
  onClickCancel,
  onClickConfirm,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClickCancel}
      shouldCloseOnOverlayClick
      className={styles.container}
    >
      <h1>{title}</h1>
      <p>{message}</p>
      <Button variation="primary" onClick={onClickCancel}>
        {cancelText}
      </Button>
      <button
        type="button"
        onClick={onClickConfirm}
        className={styles.confirmBtn}
        data-testid="confirm-button"
      >
        {confirmText}
      </button>
    </Modal>
  );
};

WarningModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  cancelText: PropTypes.string.isRequired,
  confirmText: PropTypes.string.isRequired,
  onClickCancel: PropTypes.func.isRequired,
  onClickConfirm: PropTypes.func.isRequired,
};

export default WarningModal;
